import { useEffect, useState } from "react"
import { Card, CardBody, CardHeader, Col, Input, Label, Row, Table } from "reactstrap"
import './CalculadoraMva.scss'
import Mva_ajustada from '../../../assets/images/pages/mva_ajustada.jpg'
import ModalCadastroReev from "./Modal/CadastroReev"
export default function CalculadoraMva() {
  const [mva_4, setMva_4] = useState(0)
  const [mva_7, setMva_7] = useState(0)
  const [mva_12, setMva_12] = useState(0)
  const [mva_original, setMva_original] = useState(0)
  const [aliquota_interna, setAliquota_interna] = useState(0)
  const [openModal, setOpenModal] = useState(localStorage.getItem('cadastro_reev') === null)
  const aliquotas = [
    {
      "estado": "Acre",
      "aliquota": "De 17% para 19%",
      "efeitos": "01/04/2023",
      "base_legal": "Lei Complementar nº 422/2022"
    },
    {
      "estado": "Alagoas",
      "aliquota": "De 17% para 19%",
      "efeitos": "01/04/2023",
      "base_legal": "Lei nº 8.779/2022"
    },
    {
      "estado": "Amazonas",
      "aliquota": "De 18% para 20%",
      "efeitos": "01/04/2023",
      "base_legal": "Lei Complementar nº 242/2022; Ordem de Serviço Ser/Sefaz n° 1/2023"
    },
    {
      "estado": "Bahia",
      "aliquota": "De 18% para 19%",
      "efeitos": "22/03/2023",
      "base_legal": "Lei nº 14.527/2022"
    },
    {
      "estado": "Ceará",
      "aliquota": "De 18% para 20%",
      "efeitos": "01/04/2023",
      "base_legal": "Lei nº 18.305/2023"
    },
    {
      "estado": "Maranhão",
      "aliquota": "De 18% para 20%",
      "efeitos": "01/04/2023",
      "base_legal": "Lei nº 11.867/2022"
    },
    {
      "estado": "Pará",
      "aliquota": "De 17% para 19%",
      "efeitos": "16/03/2023",
      "base_legal": "Lei nº 9.755/2022"
    },
    {
      "estado": "Paraná",
      "aliquota": "De 18% para 19%",
      "efeitos": "13/03/2023",
      "base_legal": "Lei nº 21.308/2022"
    },
    {
      "estado": "Piauí",
      "aliquota": "De 18% para 21%",
      "efeitos": "08/03/2023",
      "base_legal": "Lei Complementar nº 269/2022"
    },
    {
      "estado": "Rio Grande do Norte",
      "aliquota": "De 18% para 20%",
      "efeitos": "01/04/2023",
      "base_legal": "Lei nº 11.314/2022"
    },
    {
      "estado": "Roraima",
      "aliquota": "De 17% para 20%",
      "efeitos": "30/03/2023",
      "base_legal": "Lei nº 1.767/2022"
    },
    {
      "estado": "Sergipe",
      "aliquota": "De 18% para 22%",
      "efeitos": "20/03/2023",
      "base_legal": "Lei n° 9.120/2022"
    },
    {
      "estado": "Tocatins",
      "aliquota": "De 18% para 20%",
      "efeitos": "01/04/2023",
      "base_legal": "Medida Provisória nº 33/2022"
    }
  ]

  function calculo_mva(ALIQUOTA_INTESTADUAL) {
    if (aliquota_interna === '') {
      return parseFloat(mva_original)
    }
    let mva = 1 + (parseFloat(mva_original.toString().replace(',', '.')) / 100)
    const ALIQUOTA_INTERNA = parseFloat((1 - (parseFloat(aliquota_interna.toString().replace(',', '.')) / 100)))
    mva = (mva * (1 - ALIQUOTA_INTESTADUAL))
    mva = ((mva / ALIQUOTA_INTERNA) - 1)
    mva = parseFloat(mva) * 100
    return parseFloat(mva) < parseFloat(mva_original) ? parseFloat(mva_original) : parseFloat(mva)
  }
  useEffect(() => {
    const MVA_4 = 0.04
    const MVA_7 = 0.07
    const MVA_12 = 0.12
    if (mva_original !== '' || aliquota_interna !== '') {
      setMva_4(calculo_mva(MVA_4))
      setMva_7(calculo_mva(MVA_7))
      setMva_12(calculo_mva(MVA_12))
    } else {
      setMva_4(0)
      setMva_7(0)
      setMva_12(0)
    }
  }, [mva_original, aliquota_interna])

  return (
    <div className="container-mva">
      <ModalCadastroReev open={openModal} click={() => setOpenModal(!openModal)} />
      <h1>Calculadora de MVA Ajustada</h1>
      <Card>
        <CardBody>
          <Row className="container-inputs justify-content-center gap-2" >
            <Col xs="4" className="d-flex flex-column gap-2">
              <Row>
                <Col>
                  <Label>MVA Original</Label>
                  <Input value={mva_original} onChange={(e) => setMva_original(e.target.value)} />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Label>Alíquota Interna</Label>
                  <Input value={aliquota_interna} onChange={(e) => setAliquota_interna(e.target.value)} />
                </Col>
              </Row>
            </Col>
            <Col xs="6" style={{ "marginLeft": "4rem" }} className="d-flex align-items-center justify-content-center" >
              <div className="d-flex container-mva-result gap-2">
                <div className="card-azul-icms">
                  <Label className="text-center">MVA AJUSTADA A 4%</Label>
                  <span className="text-center w-100"> {mva_4.toFixed(2).replace('.', ',')}% </span>
                </div>
                <div className="card-azul">
                  <Label className="text-center">MVA AJUSTADA A 7%</Label>
                  <span className="text-center w-100"> {mva_7.toFixed(2).replace('.', ',')}% </span>
                </div>
                <div className="card-amarelo">
                  <Label className="text-center">MVA AJUSTADA A 12%</Label>
                  <span className="text-center w-100"> {mva_12.toFixed(2).replace('.', ',')}% </span>
                </div>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <div className="d-flex justify-content-center mt-4 mb-5">
        <a href="https://tributei.net/?utm_source=ferramentas&utm_medium=banner_ferr&utm_campaign=br-site-icms-st-ferramentas" target="_blank"> <img width="768" height="207" src={Mva_ajustada} alt="Cálculo automático de ICMS-ST online" loading="lazy" sizes="(max-width: 768px) 100vw, 768px" /> </a>
      </div>

      <Card>
        <CardHeader>
          <h3>Alíquotas internas - mudanças</h3>
        </CardHeader>
        <CardBody>
          <Table>
            <thead>
              <tr>
                <th className="text-center">ESTADO</th>
                <th className="text-center">ALTERAÇÃO NA ALÍQUOTA INTERNA GERAL</th>
                <th className="text-center">VÁLIDO A PARTIR DE </th>
                <th className="text-center">BASE LEGAL</th>
              </tr>
            </thead>
            <tbody>
              {aliquotas.map((item) => {
                return (
                  <tr>
                    <td className="text-center">{item.estado}</td>
                    <td className="text-center">{item.aliquota}</td>
                    <td className="text-center">{item.efeitos}</td>
                    <td className="text-center">{item.base_legal}</td>
                  </tr>
                )
              })}
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </div>
  )
}